import { useReactDndConstructs } from '../../../dnd/ReactDndContext';
export function useRowDragAndDrop(props) {
  const index = props.rowIndex;
  const source = {
    item: () => {
      // NOTE: begin() has been deprecated in react-dnd(v14.0.0)
      // replaced by functional version of item in react-dnd(v14.0.0)
      // @see - https://github.com/react-dnd/react-dnd/releases/tag/v14.0.0
      // @see - https://react-dnd.github.io/react-dnd/docs/api/use-drag
      props.begin?.(props.prefix);
      return {
        type: 'ROW',
        id: index,
        index,
        dndPrefix: props.prefix
      };
    },
    options: {
      dropEffect: 'copy'
    },
    collect: mon => ({
      isDragging: !!mon.isDragging(),
      rowIndex: index
    }),
    end(_monitor) {
      props.end?.();
    },
    canDrag(_monitor) {
      return props.isDraggable ? props.isDraggable(index) : true;
    }
  };
  const target = {
    accept: props.dropTypes ?? 'ROW',
    drop(item, monitor) {
      props.drop?.(item, monitor);
    },
    collect: monitor => ({
      isOver: monitor.isOver,
      isOverCurrent: monitor.isOver({
        shallow: true
      }),
      item: monitor.getItem()
    }),
    hover(item, monitor) {
      if (!dropRef) {
        return;
      }
      props.hover?.(item, monitor);
    }
  };
  const {
    useDrag,
    useDrop
  } = useReactDndConstructs();
  const [{
    isDragging,
    rowIndex
  }, dragRef, preview] = useDrag({
    // NOTE: type is now a required prop and is decoupled from item in react-dnd(v14.0.0)
    // @see - https://github.com/react-dnd/react-dnd/releases/tag/v14.0.0
    type: props.dragType ?? 'ROW',
    ...source
  });
  const [{
    isOverCurrent
  }, dropRef] = useDrop(target);
  return {
    dragRef,
    dropRef,
    isDragging,
    rowIndex,
    preview,
    isOverCurrent
  };
}
//# sourceMappingURL=useRowDragAndDrop.js.map